const initialState = {
  auth: {},
  spareAccessRights: {},
  technicalDocAccessRights: {},
  advisoriesAccessRights: {},
  notificationsAccessRights: {},
  isAllNotificateionRead: false,
  keyAndIv: {},
  notificationCount: 0,
  rollList:[],
  brandSearchv:'',
  brickSearchv:'',
  searchModelNameValuev:'',
  
  vendorSearch_:'', actionSearch_:'', brandSearch_:'', brickSearch_:'', partTypeSearch_:'', activeSearch_:'', searchModelNameValue_:'', searchArticleCodeValue_:'', searchDescriptionValue_:''
};

export default initialState;
